var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCartIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 19,
  height: 20,
  fill: "none",
  viewBox: "0 0 19 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M1.26.081a.6.6 0 1 0-.486 1.097L3.41 2.347V14.2c0 1.187.795 2.188 1.882 2.5a2.185 2.185 0 1 0 3.846.1h4.777a2.185 2.185 0 1 0 4.134.986c0-1.19-.994-2.186-2.184-2.186H6.01a1.4 1.4 0 0 1-1.4-1.4v-1.314c.246.11.52.17.806.17h11.167a2 2 0 0 0 2-2V6.803a1 1 0 0 0-.869-.99L4.61 4.076V2.282a1.1 1.1 0 0 0-.654-1.006zm3.356 10.975V5.288l12.767 1.69v4.078a.8.8 0 0 1-.8.8H5.416a.8.8 0 0 1-.8-.8m2.572 7.714a.985.985 0 1 0 0-1.969.985.985 0 0 0 0 1.97m9.661-.984a.985.985 0 1 1-1.97 0 .985.985 0 0 1 1.97 0",
  clipRule: "evenodd"
})));
export { SvgCartIcon as ReactComponent };